import API from './api';

const residuos = {
  listaCoincidencia: function (filtros, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/lista-coincidencia',
      params: filtros,
      interceptor: conInterceptor
    });
  },

  listaMatch: function (filtros, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/lista-match',
      params: filtros,
      interceptor: conInterceptor
    });
  },

  listaResiduos: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/tipo-residuos/lista',
      params: params,
      interceptor: conInterceptor
    });
  },

  factoresDeConversion: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/tipo-residuo/conversion',
      params: params,
      interceptor: conInterceptor
    });
  },

  matchAutomatico: function (conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/residuos/match-automatico',
      interceptor: conInterceptor
    });
  },

  matchManual: function (filtros, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/residuos/match',
      params: filtros,
      interceptor: conInterceptor
    });
  },

  iniciarTransaccion: function (params, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: '/transacciones',
      data: params,
      interceptor: conInterceptor
    });
  },

  resumenTransaccion: function (codigoTrasaccion, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/transacciones/${codigoTrasaccion}`,
      interceptor: conInterceptor
    });
  },

  cerrarTransacciones: function (
    params,
    codigoTrasaccion,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'put',
      url: `/transacciones/${codigoTrasaccion}`,
      data: params,
      interceptor: conInterceptor
    });
  },

  declararTransaccion: function (params, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: '/transacciones/declarar',
      data: params,
      interceptor: conInterceptor
    });
  },

  residuos: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/residuos`,
      params: params,
      interceptor: conInterceptor
    });
  },

  obtenerResiduo: function (codigoResiduo, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/residuos/${codigoResiduo}`,
      interceptor: conInterceptor
    });
  },

  eliminarResiduo: function (codigoResiduo, conInterceptor = true) {
    return API.axios({
      method: 'delete',
      url: `/residuos/${codigoResiduo}`,
      interceptor: conInterceptor
    });
  },

  editarResiduo: function (codigoResiduo, data, conInterceptor = true) {
    return API.axios({
      method: 'put',
      url: `/residuos/${codigoResiduo}`,
      data: data,
      interceptor: conInterceptor
    });
  },

  crearResiduo: function (data, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: `/residuos`,
      data: data,
      interceptor: conInterceptor
    });
  },

  // GET - Residuos  análisis territorial (Lista paginada)
  obtenerListaResiduosAT: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: '/residuos/analisis-territorial',
      params: params,
      interceptor: conInterceptor
    });
  },

  //  GET - Residuos análisis territorial (un registro)
  obtenerListaResiduoAT: function (codigoResiduoAT, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: `/residuos/analisis-territorial/${codigoResiduoAT}`,
      interceptor: conInterceptor
    });
  },

  // DELETE - Residuos análisis territorial (un registro)
  eliminarResiduoAT: function (codigoResiduoAT, conInterceptor = true) {
    return API.axios({
      method: 'DELETE',
      url: `/residuos/analisis-territorial/${codigoResiduoAT}`,
      interceptor: conInterceptor
    });
  },

  // PUT - Residuos análisis territorial (un registro)
  editarResiduoAT: function (codigoResiduoAT, data, conInterceptor = true) {
    return API.axios({
      method: 'PUT',
      url: `/residuos/analisis-territorial/${codigoResiduoAT}`,
      data: data,
      interceptor: conInterceptor
    });
  },

  // POST - Residuos análisis territorial (un registro)
  crearResiduoAT: function (data, conInterceptor = true) {
    return API.axios({
      method: 'POST',
      url: '/residuos/analisis-territorial',
      data: data,
      interceptor: conInterceptor
    });
  },

  // Obtiene una lista de residuos declarados
  obtenerListaResiduosDeclarados: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: rutas.residuosDeclarados,
      params: params,
      interceptor: conInterceptor
    });
  },

  // Obtiene un residuo declarado
  obtieneResiduoDeclarado: function (
    codigoResiduoDeclarado,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'GET',
      url: `${rutas.residuosDeclarados}/${codigoResiduoDeclarado}`,
      interceptor: conInterceptor
    });
  },

  // Obtiene un residuo declarado
  subirCertificadoResiduoDeclarado: function (
    token,
    formData,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'POST',
      url: `${rutas.residuosDeclarados}/subir-certificado`,
      interceptor: conInterceptor,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: formData
    });
  },
  subirCertificadoResiduoDeclarado_listaresiduos: function (
    formData,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'POST',
      url: `${rutas.residuosDeclarados}/subir-certificado`,
      interceptor: conInterceptor,
      // headers: {
      //   Authorization: `Bearer ${token}`
      // },
      data: formData
    });
  },

  // Crea un residuo declarado
  crearResiduoDeclarado: function (data, conInterceptor = true) {
    return API.axios({
      method: 'POST',
      url: rutas.residuosDeclarados,
      data: data,
      interceptor: conInterceptor
    });
  },

  // Actualiza un residuo declarado
  actualizaResiduoDeclarado: function (
    codigoResiduoDeclarado,
    data,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'PUT',
      url: `${rutas.residuosDeclarados}/${codigoResiduoDeclarado}`,
      data: data,
      interceptor: conInterceptor
    });
  },

  // Elimina un residuo declarado
  eliminaResiduoDeclarado: function (
    codigoResiduoDeclarado,
    conInterceptor = true
  ) {
    return API.axios({
      method: 'DELETE',
      url: `${rutas.residuosDeclarados}/${codigoResiduoDeclarado}`,
      interceptor: conInterceptor
    });
  },

  // Obtiene una lista de formato de entrega
  obtenerListaFormatoEntrega: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: rutas.formatoEntrega,
      params: params,
      interceptor: conInterceptor
    });
  },

  // Levantamiento de datos
  obtieneLevantamientoDatos: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: `${rutas.levantamientoDatos}`,
      params: params,
      interceptor: conInterceptor
    });
  },

  // Obtiene una lista de tipo de tratamiento
  obtenerListaTipoTratamiento: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: rutas.tipoTratamiento,
      params: params,
      interceptor: conInterceptor
    });
  },

  // Descargar certificado
  descargarCertificado: function (params, conInterceptor = true) {
    return API.axios({
      method: 'GET',
      url: rutas.descargaCertificado,
      params: params,
      interceptor: conInterceptor
    });
  },

  solicitarCertificado: function (
    { codigoResiduoDeclarado, correo },
    conInterceptor = true
  ) {
    return API.axios({
      method: 'POST',
      url: rutas.solicitarCertificado,
      data: {
        codigoResiduoDeclarado: codigoResiduoDeclarado,
        empresaReceptor: {
          correoContacto: correo
        }
      },
      interceptor: conInterceptor
    });
  }
};

// Rutas de los servicios
const rutas = {
  residuos: '/residuos',
  residuosDeclarados: '/residuos-declarados',
  formatoEntrega: '/formato-entrega',
  levantamientoDatos: '/levantamiento-datos',
  tipoTratamiento: '/tipos-tratamiento',
  descargaCertificado: '/residuos-declarados/descargar-certificado',
  solicitarCertificado: '/residuos-declarados/solicitar-certificado'
};

export default residuos;
